import type {
  AutoWithdrawalPayload,
  AutoWithdrawalRoutingMode,
} from '@shared/api/contracts';
import type { AutoWithdrawalDrafts, AutoWithdrawalRuleDraft } from '../model/auto-withdrawal';
import { getEnabledDirectDrafts } from './drafts';
import { normalizeDecimalForPayload } from '@shared/lib/parse-decimal';

const mapDraftToPayloadRule = (
  draft: AutoWithdrawalRuleDraft,
  sortOrder: number,
): AutoWithdrawalPayload['rules'][number] => ({
  assetCode: draft.assetCode,
  networkCode: draft.networkCode,
  destinationAddress: draft.destinationAddress.trim(),
  thresholdAmount: normalizeDecimalForPayload(draft.thresholdAmount),
  amountMode: draft.amountMode,
  reserveAmount:
    draft.amountMode === 'FULL_BALANCE'
      ? null
      : normalizeDecimalForPayload(draft.reserveAmount),
  enabled: true,
  sortOrder,
});

export const mapEnabledDraftsToPayload = (
  drafts: AutoWithdrawalDrafts,
  secondFactor?: AutoWithdrawalPayload['secondFactor'],
): AutoWithdrawalPayload => {
  const routingMode: AutoWithdrawalRoutingMode = drafts.routingMode;
  const enabledRules =
    routingMode === 'SINGLE_TARGET_SWAP'
      ? [drafts.singleDraft]
      : getEnabledDirectDrafts(drafts.directDrafts);

  return {
    routingMode,
    rules: enabledRules.map((draft, index) => mapDraftToPayloadRule(draft, index)),
    ...(secondFactor ? { secondFactor } : {}),
  };
};

export const hasRoutingModeChanged = (
  drafts: AutoWithdrawalDrafts,
  savedMode: AutoWithdrawalRoutingMode | undefined,
): boolean => Boolean(savedMode && drafts.routingMode !== savedMode);
